export default "__VITE_ASSET__BVhsiaft__"